import axios from 'axios';

const API_BASE = process.env.REACT_APP_SCENARIO_OS_API || '/scenario-os';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('scenario_os_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const u = err.config?.url || '';
    const isAuthEndpoint =
      u.includes('/learner/login') ||
      u.includes('/learner/register') ||
      u.includes('/learner/forgot-password') ||
      u.includes('/learner/reset-password');
    if (err.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('scenario_os_token');
      localStorage.removeItem('scenario_os_learner');
      const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
      window.location.href = `${base}/login`;
    }
    return Promise.reject(err);
  }
);

export const testPrepAPI = {
  startTestSession: (testId, sessionConfig) =>
    api.post('/test-prep/session/start', { test_id: testId, session_config: sessionConfig }),

  submitSection: (sessionId, sectionIndex, answers) =>
    api.post(`/test-prep/session/${sessionId}/submit-section`, {
      section_index: sectionIndex,
      answers,
    }),

  getTestResults: (sessionId) =>
    api.get(`/test-prep/session/${sessionId}/results`),

  getTestReview: (sessionId) =>
    api.get(`/test-prep/session/${sessionId}/review`),

  flagQuestion: (sessionId, questionId) =>
    api.post(`/test-prep/session/${sessionId}/flag`, {
      question_id: questionId,
    }),

  scoreTest: (sessionId) =>
    api.post(`/test-prep/session/${sessionId}/score`),

  getTimeAnalysis: (sessionId) =>
    api.get(`/test-prep/session/${sessionId}/time-analysis`),

  getReviewSummary: (sessionId) =>
    api.get(`/test-prep/session/${sessionId}/review-summary`),

  checkAnswer: (sessionId, questionId, selectedChoiceId) =>
    api.post(`/test-prep/session/${sessionId}/check-answer`, {
      question_id: questionId,
      selected_choice_id: selectedChoiceId,
    }),

  listPracticeTests: (domain) =>
    api.get(`/test-prep/${domain}/tests`),

  getScoreHistory: (domain) =>
    api.get(`/test-prep/${domain}/score-history`),
};

export default api;
